import { Component, OnInit, Input, Output, EventEmitter} from '@angular/core'
import { FDLMService } from '../../services/FDLM.Service';//SE IMPORTA EL SERVICIO
import { HttpEventType } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DocumentoSol, ConfiguraEstCredito, GetSoporteRQ, EliminaDocRQ } from '../../Interfaces';
import Swal from 'sweetalert2';

@Component({
  selector: "documentosSeparador",
  templateUrl: "./documentos-separador.component.html"
})
export class documentosSeparador implements OnInit {
  //PARAMETROS DE ENTRADA AL COMPONENTE
  @Input() varNumSolicitud: string;
  @Input() varIdPerfil: number; //1:CONSULTA VISOR SUCURSAL / 2:CONSULTA VISOR REGIONAL / 3: CONSULTA VISOR
  @Output() subirArchivoButton: EventEmitter<any>;
  @Output() evtVistaPrevia: EventEmitter<DocumentoSol>;
  @Output() evtVisPreSonido: EventEmitter<DocumentoSol>;

  public isLoaded: boolean = false;
  public lstDocumentos: Observable<DocumentoSol[]>;
  //public lstConfiguraEstCredito: Observable<ConfiguraEstCredito[]>;
  //public varEstPermiteImportar: boolean = false;
  //public varIdPerfil: string;//1:CONSULTA VISOR SUCURSAL / 2:CONSULTA VISOR REGIONAL / 3: CONSULTA VISOR
  public varIdAccionCarpertaEstCredito: number;//1: Cierra Carpeta Solicitud / 2: Abre Carpeta Solicitud / 3: Bloquea Modificación

  constructor(private FDLMService: FDLMService) {
    this.subirArchivoButton = new EventEmitter();
    this.evtVistaPrevia = new EventEmitter<DocumentoSol>();
    this.evtVisPreSonido = new EventEmitter<DocumentoSol>();
}

  public ngOnInit() {
    this.isLoaded = false;
    this.cargaInfoSolicitud();

  }
  public cargaInfoSolicitud() {
    //ENVIA A VALIDAR ESTADO DEL CREDITO
    //this.ValidaEstCredito();

    this.FDLMService.GetConfiguraEstCreditoXNumSolicitud(this.varNumSolicitud, this.FDLMService.usuarioData.idEmpSede).subscribe(
      res => {
        if (res.length !== 0) {
          res.forEach(itm => {
            this.varIdAccionCarpertaEstCredito = itm.tmpIdAccionCarpertaEstCredito;
            //CARGA DOCUMENTOS POR SOLICITUD
            this.CargarDocumentosXSolicitud();
          })
        }
        else {
          this.varIdAccionCarpertaEstCredito = 1 //1. carpeta cerrada;
          //CARGA DOCUMENTOS POR SOLICITUD
          this.CargarDocumentosXSolicitud();
        }
      }
     
    )

  }

  public CargarDocumentosXSolicitud() {   
    this.lstDocumentos = this.FDLMService.GetTblInfoDocumentosXNumSolicitud(this.varNumSolicitud, this.FDLMService.usuarioData.idEmpSede);
    this.isLoaded = true;
  }
  public importarArchivo() {
    this.subirArchivoButton.emit();
  }

  public VistaPrevia(parDocumento) {

    let strExt: string = parDocumento.strInfoDocumento.split('.').pop();
    let downloadedFile: Blob;

    if (strExt.toUpperCase() == "WAV" || strExt.toUpperCase() == "GSM") {

      this.evtVisPreSonido.emit(parDocumento);
    }
    else {
      this.evtVistaPrevia.emit(parDocumento);
    }
  }

  public Elimina(parDocumento) {
    //this.evtVistaPrevia.emit(parDocumento);
    
    Swal.fire({
      title: 'Desea eliminar el documento?',
      showCancelButton: true,
      confirmButtonText: `Eliminar`,
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        var oEliminaDocRQ = <EliminaDocRQ>{
          IdClaCab: parDocumento.tmpIdClaCab,
          IdCabVer: parDocumento.tmpIdCabVer
        }
        this.FDLMService.EliminaDoc(oEliminaDocRQ).subscribe(
          data => {
            this.CargarDocumentosXSolicitud();
          }
        );
      } 
    })
  }

  //public CargarInfoSopData() {
  //  //this.FDLMService.CargarInfoSopData("28281").toPromise().then(
  //  //  data => {
  //  //    this.tmpInfo = data;
  //  //    this.isLoaded = true;

  //  //    console.log("finaliza carga de documentos separador");
  //  //  }
  //  //);
  //}
  public DescargarArchivo(parDocumento)
  {
    //ENVIA A GUARDAR INFORMACION DE AUDITORIA=======================
    var varInfoAudCabVer = {
      tmpIdCabVer: parDocumento.tmpIdCabVer,
      tmpIdEvento: 1,//CONSULTA DEL ARCHIVO
      tmpAudIdUsuEmpSR: 1//INFOPOINT MIENTRAS SE DEFINE MANEJO DE AUTENTICACION
    };
    var oGetSoporteRQ = <GetSoporteRQ>{
      parIdCabVer: parDocumento.tmpIdCabVer,
      parFormato: "-1",
      parIdOrigen: 2 //2. Descarga Documento
    }

    var tmpRtn: any;
    this.FDLMService.GuardarAuditoriaCDocCabVer(varInfoAudCabVer).toPromise().then(
      data => {
        tmpRtn = data;

        if (tmpRtn.tmpGeneroError == "" && tmpRtn.tmpIdCabAud !== "") {

          //SE ENVIA A DESCARGAR EL ARCHIVO
          this.FDLMService.GetSoporte(oGetSoporteRQ).subscribe(
            data => {

              if (data.type != "application/json") {
                const downloadedFile = new Blob([data], { type: data.type });
                const a = document.createElement('a');
                a.setAttribute('style', 'display:none;');
                document.body.appendChild(a);
                a.download = parDocumento.strInfoDocumento;
                a.href = URL.createObjectURL(downloadedFile);
                a.target = '_blank';
                a.click();
                document.body.removeChild(a);
              }
              else {
                console.log("error descargando archivo 2");
                Swal.fire({ text: 'Error descargando documento', icon: 'warning', confirmButtonText: "Aceptar" });
              }
              
              //switch (data.type) {
              //  case HttpEventType.DownloadProgress:
              //    //this.downloadStatus.emit({ status: ProgressStatusEnum.IN_PROGRESS, percentage: Math.round((data.loaded / data.total) * 100) });
              //    break;
              //  case HttpEventType.Response:
              //    //this.downloadStatus.emit({ status: ProgressStatusEnum.COMPLETE });
              //    const downloadedFile = new Blob([data.body], { type: data.body.type });
              //    const a = document.createElement('a');
              //    a.setAttribute('style', 'display:none;');
              //    document.body.appendChild(a);
              //    a.download = parDocumento.strInfoDocumento;
              //    a.href = URL.createObjectURL(downloadedFile);
              //    a.target = '_blank';
              //    a.click();
              //    document.body.removeChild(a);
              //    break;
              //}
            },
            error => {
              console.log("error descargando archivo 2");
              Swal.fire({ text: 'Error descargando documento', icon: 'warning', confirmButtonText: "Aceptar" });
            }
          );

        }
        else {
          console.log("Error guardando auditoria " + tmpRtn.tmpStrError);
          Swal.fire({ text: 'Error guardando auditoria', icon: 'warning', confirmButtonText: "Aceptar" });
        }
      }
    );
    //===============================================================
  }


  //public ValidaPerfilYEstCredito(parIdPerfil) {
  //  this.varIdPerfil = parIdPerfil;
  //  //SI EL PERFIL ES USUARIO SUCURSAL Y EL ESTADO DE CREDITO <> CIERRA CARPETA SOLICITUD
  //  if (this.varIdPerfil === 1 && this.varIdAccionCarpertaEstCredito!==1) {
  //    this.varEstPermiteImportar = true;//PERMITE IMPORTAR
  //  }
  //  else {
  //    this.varEstPermiteImportar = false;//NO PERMITE IMPORTAR
  //  }

  //}
  //public ValidaEstCredito() {
  //  //ENVIA A CONSULTAR CONFIGURACION DE ESTADO DE CREDITO
  //  this.lstConfiguraEstCredito = this.FDLMService.GetConfiguraEstCreditoXNumSolicitud(this.varNumSolicitud, this.FDLMService.usuarioData.idEmpSede);

  //  this.lstConfiguraEstCredito.forEach(tmpConfEstCredito => tmpConfEstCredito.forEach(tmpInfoConfEstCredito => {
  //    this.varIdAccionCarpertaEstCredito = tmpInfoConfEstCredito.tmpIdAccionCarpertaEstCredito
  //  }));
  //}
}
